import styled from 'styled-components';
import theme from '../../theme/theme';

export const Container = styled.div`
    margin: 0 4rem;
`;

export const IconSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 110px;
    // background-color: ${theme.color.silver};
    margin-bottom: 30px;
`;

export const MainHeader = styled.div`
@media (max-width: 400px) {
  margin-left: 20px;
}
`;

export const Title = styled.h1`
  font-family: 'Inter', sans-serif;
  font-size: 55px;
  margin: 0;
  font-weight: 800;
  padding-top: 50px;
  margin-bottom: 15px;
  color: ${theme.color.navy};
  @media (max-width: 420px) {
    font-size: 40px;
    padding-top: 30px;
  }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 30px 0 0.7rem 0;
`;

export const TableHeader = styled.h2`
    font-size: 2rem;
    font-weight: 700;
    color: ${theme.color.navy};
    margin: 0;
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-left: auto;
`;